(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('ProfileCriterionItemDeleteController',ProfileCriterionItemDeleteController);

    ProfileCriterionItemDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProfileCriterionItem'];

    function ProfileCriterionItemDeleteController($uibModalInstance, entity, ProfileCriterionItem) {
        var vm = this;

        vm.profileCriterionItem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProfileCriterionItem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
